// extracted by mini-css-extract-plugin
module.exports = {"Salary":"Salary_Salary__2NPIz"};